import {
  Box,
  Button,
  Typography,
  Modal,
  Grid,
  Divider,
  IconButton,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CloseIcon from "@mui/icons-material/Close";

import { useDispatch, useSelector } from "react-redux";
import { setAppoinmentType } from "../app/store/reducer";
import { routePath } from "../constants/routePath";
import { getAll } from "./appoinmentModalppbnApi";
import CardPayment from "../features/payment/cardPayment";
import Salary from "../features/employeePayRoll/salary";
import CardPaymentAppoinment from "./appoinmentModalCard";
import profile_login from "../assets/img/profile_login_img.png"
import otp_login from "../assets/img/otp_login.png"
const ApModal = ({ open, setOpen, setFilterBy }) => {
  const [CollectionTableItems, setCollectionTableItems] = useState([]);
  const infoD = useSelector((state) => state.reducer.detail);

  const cardKet = {
    SalaryComponents: [
      {
        key: "employeeName",
        label: "Employee Name",
      },
      {
        key: "componentName",
        label: "Component Name",
      },
      {
        key: "amount",
        label: "Amount",
      },
      // {
      //   key: "percentage",
      //   label: "Percentage",
      // },
    ],

    incentrive: [
      {
        key: "employeeName",
        label: "Employee Name",
      },
      {
        key: "incentiveName",
        label: "Incentive Name",
      },
      {
        key: "minimumValue",
        label: "Minimum Value",
      },
      {
        key: "maximumValue",
        label: "Maximum Value",
      },

      {
        key: "percentage",
        label: "Percentage",
      },
    ],
    Deductions: [
      {
        key: "employeeName",
        label: "Employee Name",
      },
      {
        key: "componentName",
        label: "Deduction Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      // {
      //   key: "percentage",
      //   label: "Percentage",
      // },
    ],
    otherAllowence: [
      {
        key: "employeeName",
        label: "Employee Name",
      },
      {
        key: "allowanceName",
        label: "Allowance Name",
      },
      {
        key: "amount",
        label: "Amount",
      },

      // {
      //   key: "percentage",
      //   label: "Percentage",
      // },
    ],
  };
  const [indexTableItem, setIndexTableItem] = useState();
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateRoute = (e) => {
    dispatch(setAppoinmentType(e.target.id));
    if (e.target.id == "profile") {
      if (userDetail && Object.keys(userDetail).length > 0) {
        navigate(routePath.APPOINMENT);
      } else {
        navigate(routePath.LOGIN);
      }
    } else {
      navigate(routePath.APPOINMENT);
    }
  };
  const [collection, setCollection] = useState([]);
  useEffect(() => {
    if (infoD?.billerId) {
      getAll(
        {
          billerId: 10,
          page: 1,
          pageSize: 1000,
        },
        (res) => {
          console.log("getAll res ", res?.data?.data?.list);
          setCollection(res?.data?.data?.list);
        }
      );
    }
  }, [infoD]);
  return (
    <Box>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
      >
        <Box
          sx={{
            background: "white",
            padding: "24px",
            width: { xs: "90%", sm: "70%", md: "50%" },
            maxHeight: "80vh",
            overflowY: "auto",
            borderRadius: "12px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 3,
          }}
        >
          {/* Header with Close Button */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography
              variant="h6"
              sx={{ color: (theme) => theme.palette.primary.main }}
            >
              Book New Appointment
            </Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />

          {/* Login Options */}
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={2}
            mt={3}
          >
            <Button variant="contained" id="profile" onClick={navigateRoute}>
              Profile Login
            </Button>
            <Typography>Or</Typography>
            <Button variant="contained" id="otp" onClick={navigateRoute}>
              OTP Verification
            </Button>
          </Box>

          {/* Cards Grid */}
          <Grid container spacing={2} mt={3}>
            {collection?.map((ele, index) => (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <CardPaymentAppoinment item={ele} cardKet="Salary" />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Modal>

      {/* <Box display={"flex"} gap={4}>
        <IconButton
          size="small"
          sx={{ mb: 2, mt: 6, mx: 10 }}
          onClick={() => navigate(routePath.SERVICESLIST)}
        >
          <KeyboardBackspaceIcon sx={{ color: "#01008B", fontSize: "30px" }} />
        </IconButton>
        <Typography variant="h6" fontWeight={600} fontSize={30}>
          Book New Appointment With
        </Typography>
      </Box>

      <Box display={'flex'} gap={4}>
        <Box sx={{ border: "2px solid red", borderRadius: 1 }}>
        <img src={profile_login} alt="image" style={{ width: "100%" }} />
      </Box>
      <Box sx={{ border: "2px solid red", borderRadius: 1 }}>
        <img src={otp_login} alt="image" style={{ width: "100%" }} />
      </Box>
      </Box> */}
    </Box>
  );
};
export default ApModal;
